import type { ReactNode } from "react";

/** One-line text summary required above every chart. Apart from Charts.tsx so it doesn't pull Recharts in. */
export function ChartSummary({ children }: { children: ReactNode }) {
  return <p className="text-subhead text-muted">{children}</p>;
}
